import { useCallback, useEffect, useRef, useState } from 'react';

export const useOnActionToggle = ( data ) => {
  const { watch, loading } = data || {};
  const [show, setShow] = useState( watch );

  const actionDispatched = useRef( false );

  const onActionDispatched = useCallback( () => {
    actionDispatched.current = true;
  }, [actionDispatched] );

  useEffect( () => {
    if( !actionDispatched.current || loading || show === !!watch ){
      return;
    }

    actionDispatched.current = false;

    setShow( !!watch );
  }, [watch, actionDispatched, loading] );

  return [onActionDispatched, show, setShow];
};
